import { usePortalClasses } from '@components/Datagrid/hooks'

export function Portal({ className }: { className?: string }) {
  usePortalClasses(className)

  return null
}
